module.exports = __webpack_public_path__ + "assets/img/shane.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shane.png
// module id = 1975
// module chunks = 0